import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { HomePage } from '../../../home/home';
import { KitchenPage } from '../../../kitchen/kitchen';

@Component({
  selector: 'page-tutorial-kitchen',
  templateUrl: 'tutorial-kitchen.html',
})
export class TutorialKitchenPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public dishServices: DishServices) {

  }

  close() {
    if (this.globals.checkLimitsByLicense('kitchen', 'kitchen')) {//miramos los limites de la licencia
      this.globals.side_menu_active = 'kitchen';
      this.navCtrl.setRoot(KitchenPage);
      this.globals.side_menu_active_analytics = false;
    } else {
      this.navCtrl.push(HomePage);
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/help/tutorials/tutorial-kitchen/tutorial-kitchen.ts